import { render, staticRenderFns } from "./OrganizationSignatoryCreateAndEditDialog.vue?vue&type=template&id=215b16a8&scoped=true"
import script from "./OrganizationSignatoryCreateAndEditDialog.vue?vue&type=script&lang=js"
export * from "./OrganizationSignatoryCreateAndEditDialog.vue?vue&type=script&lang=js"
import style0 from "./OrganizationSignatoryCreateAndEditDialog.vue?vue&type=style&index=0&id=215b16a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "215b16a8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
